import { useNavigate } from "react-router-dom";

import { Button } from "../ui/button";
import { Card, CardContent, CardTitle } from "../ui/card";

interface AccessDeniedProps {
  message?: string | null;
  courseId?: number | null;
  onRetry?: () => void;
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({ message, courseId, onRetry }) => {
  const navigate = useNavigate();
  const description = message ?? 'If you believe this is a mistake, please contact an administrator or support@wisefriend.org.';

  return (
    <main className="flex min-h-[calc(100vh-120px)] items-center justify-center px-4 py-6">
      <Card maxWidth="narrow" className="w-full max-w-md">
        <CardTitle
          centered={true}
          title={
            <p className="leading-tight">
              {onRetry ? 'Unable to load this lesson' : 'This content is unavailable'}
            </p>
          }
          subtitle={
            <div>
              {description}
            </div>
          }
        />

        <CardContent
          variant="custom"
          className="pt-4 flex flex-col items-center gap-3"
        >
          {onRetry ? <Button onClick={onRetry} size="auto">Try again</Button> : null}
          <Button
            variant="default"
            onClick={() => navigate(courseId ? `/training?courseId=${courseId}#courses` : "/training#courses")}
            size="auto"
          >
            Go to My Courses
          </Button>
          <Button
            variant="secondary"
            onClick={() => navigate("/home")}
            size="auto"
          >
            Return to Dashboard
          </Button>
        </CardContent>
      </Card>
    </main>
  );
};
